import { ISuKienSelectByGiaiDoanIdxRequest } from "../../../model/request/tkb/ISuKienSelectByGiaiDoanIdxRequest";
import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { IStuNhomLopViewModel } from "../../../model/respone/category/IStuNhomLopViewModel";
import { ISuKienViewModel } from "../../../model/respone/lop-tin-chi/ISuKienViewModel";
import { eReducerStatusBase } from "../eReducerStatusBase";
export enum eXepTKBStatus {
    is_loading_kh = "is_loading_kh",
    is_completed_kh = "is_completed_kh",
}
export interface IPhanPhongHocReducer {
    status: eReducerStatusBase | eXepTKBStatus,
    filter: ISuKienSelectByGiaiDoanIdxRequest,
    suKiens: ISuKienViewModel[],
    monHocs: IMonHoc[],
    nhomLops: IStuNhomLopViewModel[],
    phongHocSelectedId: number;
}
